import React from 'react'
import {myConfig} from '../config/myConfig'
import Container from '../wrapper/Container'
import {Col,Row} from 'react-flexbox-grid'
const blue = myConfig.blueLight
// Auccune dépendance pour pouvoir utiliser sur plusieurs application

const styles={}
styles.link={color:blue,fontWeight:'normal',textDecoration:'none'}
styles.linkIcon={display:'flex',alignItems:'center',borderRadius:'50%',height:20,width:20,border:`2px solid ${blue}`,color:blue,fontWeight:'bold',textDecoration:'none'}


const Footer = ()=>
  <div>
    <Container
      containerOutStyle={{borderTop:'1px solid',borderTopColor:blue}}
      containerInStyle={{width:'100%',minHeight:80,paddingTop:10,boxSizing:'border-box',fontSize:12,fontFamily:'sans-serif'}}>

      <Row>
        <Col xs={12} sm={8}>
          <a style={styles.link} rel="noopener noreferrer" href='http://www.dourous-sounnah.com/' target='_blank'><i className='fas fa-link' style={{width:25}}/> Dourous-sounnah.com </a> <br/>
          <a style={styles.link} rel="noopener noreferrer" href='http://www.institutsounnah.com/' target='_blank'><i className='fas fa-link' style={{width:25}}/> Institutsounnah.com </a> <br/>
          <p><i className='fas fa-info' style={{width:25}}/> v1.1</p>
        </Col>

        <Col xs={12} sm={4} style={{}}>
          <a style={styles.link} rel="noopener noreferrer" href='mailto:contact@institutsounnah.com' ><i className='fas fa-envelope' style={{width:25}}/> contact@institutsounnah.com</a> <br/>
          <a style={styles.link} rel="noopener noreferrer" href='https://twitter.com/douroussounnah' target='_blank'><i className='fab fa-twitter' style={{width:25}}/> Twitter </a> <br/>
          <a style={styles.link} rel="noopener noreferrer" href='https://www.facebook.com/DourousSounnah/' target='_blank'><i className='fab fa-facebook-f' style={{width:25}}/> Facebook </a><br/>
        </Col>

      </Row>


    </Container>

    <div style={{textAlign:'center',boxSizing:'border-box',height:30,fontSize:12,padding:10,color:myConfig.blueLight}}>
          © 2019 Institut Sounnah - Tous droits réservés.
    </div>
  </div>

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.jsx